import EmailIcon from '@mui/icons-material/MailOutlineRounded';
import { Box, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import moment from "moment";
import React, { useState } from "react";
import { EmailBody } from "../../../types/files";
import EmailSummaryModal from "../../modals/dashboard-queries/EmailSummaryModal";
import ContentSummaryAnswer from "../dashboard-query-answer/ContentSummaryAnswer";

const useStyles = makeStyles((theme) => ({
    card: {
        width: '100%',
        minWidth: 450,
        maxWidth: 'calc(33vw - 80px)',
        height: 'fit-content',
        padding: 16,
        borderRadius: 16,
        backgroundColor: '#fff',
        border: `1px solid ${theme.colors.neutral['500']}`,
        boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2)',
        transition: '0.05s ease-in-out',
        "&:hover": {
            boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2), 0px 5px 8px 0px rgba(16, 24, 40,0.14), 0px 1px 14px 0px rgba(16, 24, 40,0.12)',
        },
    },
    title: {
        display: '-webkit-box',
        width: 'fit-content',
        fontSize: '1.1rem',
        fontFamily: 'Poppins',
        overflow: 'hidden',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        textTransform: 'capitalize',
        maxWidth: '24ch',
    },
    bodyContentBlock: {
        width: '100%',
        height: 'fit-content',
        minHeight: '105px',
        maxHeight: '210px',
        overflowY: 'auto',
        marginTop: '16px',
        padding: '8px',
    },
    bodyText: {
        color: 'black',
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        whiteSpace: 'pre-wrap',
    },
    ownership: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: '500',
        color: theme.colors.neutral['500'],
    },
    owner: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        fontWeight: 600,
        color: theme.palette.primary.main,
    },
    subject: {
        display: '-webkit-box',
        width: 'fit-content',
        fontFamily: 'Poppins',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: theme.colors.neutral['500'],
        overflow: 'hidden',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        textTransform: 'capitalize',
        maxWidth: '40ch',
        wordBreak: 'break-all',
    },
    timestamp: {
        fontFamily: 'Inter',
        fontSize: '0.75rem',
        fontWeight: 500,
        color: theme.colors.neutral['600'],
        textAlign: 'right',
    },
    icon: {
        width: 28,
        height: 28,
    },
}));

const DashboardAssignedContentCard: React.FC<{
    content: EmailBody & {summary : string},
}> = ({ content }) => {
    const classes = useStyles();
    const [viewableEmail, setViewableEmail] = useState<(EmailBody & {summary : string})|null>(null);

    return (<>
        <Box className={classes.card}>
            <Stack direction="row" alignItems="flex-start" width="100%" >
                <Box width="40px" mt="6px" pl="2px">
                    <EmailIcon className={classes.icon} sx={{ fill: '#7bd4d4 !important'}} />
                </Box>
                <Stack direction="column" spacing="4px" alignItems="flex-start" justifyContent="center" width="100%" py={1}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" pl={1} width="100%">
                        <Typography className={classes.subject} width="100%">
                            {content.subject?.replace('Fwd:', '')?.replace('Fw:', '') || '<Untitled>'}
                        </Typography>
                        <Typography className={classes.timestamp} width="30%">
                            {`${moment(content.createdAt).fromNow()}`}
                        </Typography>
                    </Stack>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" pl={1} width="100%">
                        <Stack direction="row" alignItems="center" justifyContent="flex-start">
                            <Typography className={classes.ownership}>
                                {'From: '}
                                <Typography component="span" className={classes.owner} display="inline" pl="4px">
                                    {!!content.from ? content.from.replace(/<.*?>/g, '').trim() : 'N/A'}
                                </Typography>
                            </Typography>
                        </Stack>
                    </Stack>
                    <Box width="100%" height="100%" pt={1}>
                        <ContentSummaryAnswer content={content!} onViewEmail={setViewableEmail} />
                    </Box>
                </Stack>
            </Stack>
        </Box>
        {!!viewableEmail && (
            <EmailSummaryModal
                emailContent={viewableEmail}
                open={!!viewableEmail}
                onClose={() => setViewableEmail(null)} />
        )}
    </>);
};

export default DashboardAssignedContentCard;
